import { render, staticRenderFns } from "./tareasPersonales.vue?vue&type=template&id=39f303d0"
import script from "./tareasPersonales.vue?vue&type=script&lang=js"
export * from "./tareasPersonales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports